import { z } from 'zod';

export const CURRENCIES = [
  'EUR',
  'TRY',
  'USD',
  'GBP',
  'CHF',
  'SEK',
  'NOK',
  'DKK',
  'PLN',
  'CZK',
  'RON',
  'BGN',
  'AED',
  'SAR',
] as const;

export type Currency = (typeof CURRENCIES)[number];

export const currencySchema = z.enum(CURRENCIES);

const MINOR_UNIT_DIGITS: Partial<Record<Currency, number>> = {};

export function minorUnitDigits(currency: Currency): number {
  return MINOR_UNIT_DIGITS[currency] ?? 2;
}

export function minorUnitFactor(currency: Currency): bigint {
  return 10n ** BigInt(minorUnitDigits(currency));
}

export function isCurrency(value: string): value is Currency {
  return (CURRENCIES as readonly string[]).includes(value);
}
